import { createContext, useContext } from 'react';
import type { PanelConfig } from '../../types/LayoutConfig';

export interface MobileLayoutPanelContextValue {
  updatePanelParams: (paramsPatch: Partial<PanelConfig>) => void;
}

export const MobileLayoutPanelContext = createContext<MobileLayoutPanelContextValue | undefined>(undefined);
MobileLayoutPanelContext.displayName = 'MobileLayoutPanelContext';

export function useMobileLayoutPanel() {
  const context = useContext(MobileLayoutPanelContext);
  if (context === undefined) {
    throw new Error('Missing MobileLayoutPanelProvider further up in the tree. Did you forget to add it?');
  }
  return context;
}
